<template>
  <div class="text-start">
    <div v-show="errorSingle" class="alert alert-danger">
      {{ errorSingle }}
    </div>
    <div>شناسه: {{ productDetailVideoId }}</div>
    <div class="row mt-3">
      <div class="col-md-3 col-sm-6 col-xs-12">
        <div class="mb-3">
          <label for="name"> تاریخ شروع *</label>
          <DatePicker v-model="state.date" :key="datePickerKey" />
        </div>
      </div>

      <div class="col-md-3 col-sm-6 col-xs-12">
        <div class="form-floating mb-3">
          <input
            type="time"
            class="form-control"
            placeholder="از ساعت"
            v-model="singleSessionData.from_time"
          />
          <label for="name">از ساعت *</label>
        </div>
      </div>

      <div class="col-md-3 col-sm-6 col-xs-12">
        <div class="form-floating mb-3">
          <input
            type="time"
            class="form-control"
            placeholder="تا ساعت"
            v-model="singleSessionData.to_time"
          />
          <label for="name">تا ساعت *</label>
        </div>
      </div>

      <div class="col-md-3 col-sm-6 col-xs-12">
        <div class="form-floating mb-3">
          <input
            type="text"
            class="form-control"
            placeholder="قیمت"
            v-model="singleSessionData.price"
            :keyup="monize()"
          />
          <label for="name"> قیمت *</label>
        </div>
      </div>

      <div class="col-md-3 col-sm-6 col-xs-12">
        <div class="form-floating mb-3">
          <input
            type="text"
            class="form-control"
            placeholder="نام جلسه"
            v-model="singleSessionData.name"
          />
          <label for="name"> نام (می‌تواند خالی باشد) </label>
        </div>
      </div>
      <div class="col-md-3 col-sm-6 col-xs-12">
        <div class="form-floating mb-3">
          <select
            class="form-control"
            v-model="singleSessionData.video_session_type"
          >
            <option value="offline">آفلاین</option>
            <option value="online">آنلاین</option>
          </select>
          <label>نوع </label>
        </div>
      </div>
      <div class="col-md-3 col-sm-6 col-xs-12">
        <div class="form-floating mb-3">
          <select class="form-control" v-model="singleSessionData.is_hidden">
            <option value="0">قابل نمایش</option>
            <option value="1">پنهان</option>
          </select>
          <label> نمایش </label>
        </div>
      </div>

      <div class="col-md-3 col-sm-6 col-xs-12">
        <div class="form-floating mb-3">
          <select
            class="form-control"
            v-model="singleSessionData.extraordinary"
          >
            <option value="0">خیر</option>
            <option value="1">بله</option>
          </select>
          <label> فوق العاده </label>
        </div>
      </div>
      <div v-if="singleSessionData" class="col-md-9 col-sm-12 col-xs-12">
        <div>
          <input
            :checked="singleSessionData.video_session.is_aparat > 0"
            @change="changeAparatStatus"
            type="checkbox"
          />
          آپارات
        </div>
        <div
          v-if="!singleSessionData.video_session.is_aparat"
          class="form-floating mb-3"
        >
          <input
            type="text"
            class="form-control"
            placeholder="لینک ویدیو"
            v-model="singleSessionData.video_link"
          />
          <label>لینک ویدیو</label>
        </div>
        <div v-if="singleSessionData.video_session.is_aparat" class="mb-3">
          <textarea
            type="text"
            class="form-control"
            placeholder="کد آی فریم آپارات"
            v-model="singleSessionData.video_link"
            rows="5"
          >
          </textarea>
        </div>
      </div>

      <div class="col-md-3 col-sm-6 col-xs-12">
        <div class="form-floating mb-3">
          <select
            class="form-control"
            v-model="singleSessionData.single_purchase"
          >
            <option value="1">بله</option>
            <option value="0">خیر</option>
          </select>
          <label> قابلیت فروش تکی </label>
        </div>
      </div>

      <div class="col-md-6 col-xs-12 mt-1">
        <label v-show="singleSessionData.files.length > 0">فایل/ها</label>
        <div
          v-for="item in singleSessionData.files"
          :key="item.id"
          class="
            border
            d-flex
            justify-content-between
            mt-1
            p-2
            rounded-1
            text-decoration-none
          "
        >
          <a :href="API_STORAGE_URL + item.file_path" target="_blank">
            <i class="fas fa-download"></i>
            {{ item.name }}
          </a>
          <a class="text-danger mx-1" @click="deleteFile(item.id)">
            <i class="fas fa-trash"></i>
          </a>
        </div>
      </div>

      <div class="col-md-3 col-xs-12 mt-1">
        <div class="form-floating">
          <input
            type="text"
            class="form-control"
            id="file_name"
            placeholder="عنوان فایل جدید"
            v-model="fileName"
          />
          <label for="file_name"> عنوان فایل جدید </label>
        </div>

        <div class="form-floating mt-3">
          <select class="form-control" v-model="file_id">
            <option v-for="item in files" :key="item.id" :value="item.id">
              {{ item.name }}
            </option>
          </select>
          <label>فایل های از پیش بارگذاری شده</label>
        </div>
      </div>

      <div class="col-md-3 col-xs-12">
        <div v-show="fileError" class="alert alert-danger">
          {{ fileError }}
        </div>
        <input
          class="form-control form-control-sm my-1"
          id="session_file"
          type="file"
          @change="addUploadFile($event)"
        />

        <div class="my-0">
          <a class="btn btn-sm btn-success" @click="setSessionFile()">
            <i class="fas fa-plus"></i>
            ذخیره فایل
          </a>
          <span
            v-show="showFileSpin"
            class="fas fa-spinner fa-spin mt-3"
          ></span>
        </div>

        <div class="my-0">
          <a class="btn btn-sm btn-success my-4" @click="assignFile()">
            <i class="fas fa-plus"></i>
            تخصیص فایل
          </a>

          <span
            v-show="showFileSpin"
            class="fas fa-spinner fa-spin mt-3"
          ></span>
        </div>
      </div>

      <div class="fw-bold my-2">اطلاعات مربوط به همایش رایگان</div>
      <div class="col-md-3 col-xs-6">
        <div class="form-floating mb-3">
          <select
            class="form-select"
            v-model="singleSessionData.free_conference_start_mode"
          >
            <option value="productPage">صفحه نمایش جلسه</option>
            <option value="playPage">صفحه پخش ویدیو</option>
          </select>
          <label>کاربر پس از لاگین به این صفحه هدایت شود</label>
        </div>
        <div v-if="singleSessionData.free_conference_description" class="my-2">
          <router-link
            target="_blank"
            :to="{
              name: 'RegisterLoginFreeConference',
              params: { product_detail_videos_id: singleSessionData.id },
            }"
          >
            لینک همایش
          </router-link>
        </div>
      </div>

      <div class="col-md-9 col-xs-6">
        <label> توضیحات همایش رایگان: </label>
        <textarea
          class="form-control mb-3 mt-1"
          rows="3"
          name="free_conference_description"
          placeholder="توضیحات همایش رایگان"
          v-model="singleSessionData.free_conference_description"
        ></textarea>

        <label>توضیحات پیش از شروع همایش:</label>
        <textarea
          class="form-control my-1"
          rows="3"
          name="free_conference_before_start_text"
          placeholder="توضیحات پیش از شروع همایش "
          v-model="singleSessionData.free_conference_before_start_text"
        ></textarea>
      </div>

      <div class="col-md-12 col-sm-12 col-xs-12">
        <a class="btn btn-primary" @click="editSingleSession()">
          ذخیره تک جلسه
        </a>
        <span v-show="showSpin" class="fas fa-spinner fa-spin mt-3"></span>

        <button
          type="button"
          class="btn btn-secondary float-end"
          data-bs-dismiss="modal"
        >
          بستن
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import arefApi from "../libs/api";
import utils from "../libs/utils";
import jmoment from "moment-jalaali";
import DatePicker from "vue3-persian-datepicker";
import "vue3-persian-datepicker/dist/datepicker.min.css";
import { reactive } from "@vue/reactivity";

export default {
  name: "EditProductDetailVideo",
  props: {
    productDetailVideoId: Number,
    page: Number,
    files: Array,
  },
  data() {
    return {
      singleSessionData: {
        date: null,
        from_time: null,
        to_time: null,
        is_hidden: 0,
        extraordinary: 0,
        price: 0,
        name: null,
        products_id: this.$route.params.productId
          ? this.$route.params.productId
          : null,
        video_session_type: "offline",
        video_link: null,
        single_purchase: 1,
        files: [],
        video_session: {
          is_aparat: 0,
        },
        is_aparat:0
      },
      errorSingle: null,
      showSpin: false,
      datePickerKey: "0",
      fileName: null,
      sessionFile: null,
      showFileSpin: false,
      fileError: null,
      API_STORAGE_URL: process.env.VUE_APP_API_STORAGE_URL,
      file_id: null,
    };
  },
  setup() {
    const state = reactive({ date: "" });
    return {
      DatePicker,
      state,
    };
  },
  created() {
    this.arefApi = new arefApi();
    this.utils = new utils();
    this.jmoment = new jmoment();
  },
  components: {},
  methods: {
    monize() {
      this.singleSessionData.price = this.utils.monize(
        this.singleSessionData.price
      );
    },
    getProductVideoSessionInfo(newval) {
      this.arefApi.getProductVideoSessionInfo(newval).then((resp) => {
        this.singleSessionData = resp.data;
        this.singleSessionData.date = resp.data.video_session.start_date;
        this.state.date = jmoment(this.singleSessionData.date).format(
          "jYYYY/jMM/jDD"
        );
        this.datePickerKey = resp.data.video_session.id.toString();
        this.singleSessionData.from_time = resp.data.video_session.start_time;
        this.singleSessionData.to_time = resp.data.video_session.end_time;
        this.singleSessionData.video_link = resp.data.video_session.video_link;
        this.singleSessionData.is_aparat = resp.data.video_session.is_aparat;
        this.singleSessionData.video_session_type =
          resp.data.video_session.video_session_type;
        this.singleSessionData.products_id = resp.data.product.id;
      });
    },
    editSingleSession() {
      this.singleSessionData.date = jmoment(
        this.state.date,
        "jYYYY/jM/jD"
      ).format("YYYY-MM-DD");
      this.singleSessionData.price =
        this.singleSessionData.price == 0
          ? 0
          : Number(this.singleSessionData.price.replace(/,/g, ""));
      this.arefApi
        .editProductVideoSession(this.singleSessionData)
        .then(() => {
          this.utils.showSuccess(this);
          this.getProductVideoSessions();
        })
        .catch((err) => {
          this.utils.showErrors(this, err);
        });
    },
    addUploadFile(event) {
      this.sessionFile = event.target.files[0];
    },
    setSessionFile() {
      this.fileError = null;
      if (!this.fileName) {
        this.fileError = "عنوان فایل را انتخاب فرمایید";
        return;
      }
      if (!this.sessionFile) {
        this.fileError = "فایل  را انتخاب فرمایید";
        return;
      }

      this.showFileSpin = true;
      let formDataTmp = new FormData();
      formDataTmp.append("file", this.sessionFile);
      formDataTmp.append("name", this.fileName);
      formDataTmp.append(
        "product_detail_videos_id",
        Number(this.productDetailVideoId)
      );
      this.arefApi
        .setVideoSessionFile(formDataTmp)
        .then(() => {
          this.utils.showSuccess(this);
          this.getProductVideoSessionInfo(this.productDetailVideoId);
          document.getElementById("session_file").value = "";
          this.fileName = null;
          this.sessionFile = null;
        })
        .catch((err) => {
          this.utils.showErrors(this, err);
        })
        .finally(() => {
          this.showFileSpin = false;
        });
    },
    deleteFile(fileId) {
      this.$swal
        .fire({
          title: "اخطار حذف",
          text: "آیا حذف انجام شود؟",
          icon: "warning",
          showCancelButton: true,
          cancelButtonText: "خیر",
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "بله حذف انجام شود!",
        })
        .then((value) => {
          if (value.isConfirmed) {
            this.arefApi
              .deleteSessionFile(fileId)
              .then(() => {
                this.$swal.fire({
                  title: "",
                  text: `حذف فایل با موفقیت انجام شد`,
                  icon: "success",
                  confirmButtonText: "متوجه شدم",
                });
                this.getProductVideoSessionInfo(this.productDetailVideoId);
              })
              .catch((err) => {
                this.utils.showErrors(this, err);
              });
          }
        });
    },
    getProductVideoSessions() {
      this.$parent.getProductVideoSessions(this.page);
    },
    assignFile() {
      this.fileError = null;
      if (!this.file_id) {
        this.fileError = "لطفا نام فایل از پیش بارگذاری شده را انتخاب نمایید";
        return;
      }
      const obj = {
        files_id: this.file_id,
        product_detail_videos_id: this.singleSessionData.id,
      };
      this.arefApi
        .assignFile(obj)
        .then(() => {
          this.getProductVideoSessionInfo(this.productDetailVideoId);
          this.utils.showSuccess(this);
        })
        .catch((err) => {
          this.utils.showErrors(this, err);
        });
    },
    changeAparatStatus() {
      const tmp = this.singleSessionData.video_session.is_aparat == 0 ? 1 : 0;
      this.singleSessionData.is_aparat = tmp;
      this.singleSessionData.video_session.is_aparat = tmp;
    },
  },
  watch: {
    productDetailVideoId: function (newVal) {
      this.getProductVideoSessionInfo(newVal);
    },
  },
};
</script>
